import React from "react";
import { useNavigate } from "react-router-dom";
import { SectionCard, SecondaryButton } from "@/components/ds";

interface Props {
  name: string;
  description?: string;
}

/**
 * Shown when a user navigates to an integration config page
 * but their subscription doesn't include that integration.
 * Future: replace the CTA with a self-serve upgrade flow.
 */
export default function IntegrationNotEnabled({ name, description }: Props) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-64 py-16 px-6">
      <div className="max-w-md w-full">
        <SectionCard title={name}>
          <div className="text-center">
            <div className="w-14 h-14 rounded-full bg-zinc-100 flex items-center justify-center mx-auto mb-4">
              <svg className="w-7 h-7 text-zinc-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 10.5V6.75a4.5 4.5 0 119 0v3.75M3.75 21.75h10.5a2.25 2.25 0 002.25-2.25v-6.75a2.25 2.25 0 00-2.25-2.25H3.75a2.25 2.25 0 00-2.25 2.25v6.75a2.25 2.25 0 002.25 2.25z" />
              </svg>
            </div>

            <p className="text-sm text-zinc-500 mb-6">
              {description ?? "Velaro needs to enable this for your account, which may require an upgrade. Reach out to your Velaro contact or support to get started."}
            </p>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a
                href="mailto:support@velaro.com?subject=Enable Integration"
                className="px-5 py-2.5 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700 transition-colors"
              >
                Contact Velaro support
              </a>
              <SecondaryButton onClick={() => navigate("/integrations")}>
                Back to Integrations
              </SecondaryButton>
            </div>
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
